import { Reducer } from '@reduxjs/toolkit';

import { defaultCareGapFilters, defaultTrialFilters } from './constants';
import { TIMEScreeningState, TIMEScreeningActions } from '../api/types/timeScreeningStore';

const defaultState: TIMEScreeningState = {
  careGap: {
    filters: {
      ...defaultCareGapFilters,
    },
    options: {
      carePathways: [],
      carePathwayQueueCounts: null,
      stages: [],
      sites: [],
    },
  },
  trials: {
    filters: {
      ...defaultTrialFilters,
    },
    savedFilters: {
      locationStatuses: defaultTrialFilters.locationStatuses,
      matchScoreMin: defaultTrialFilters.matchScoreMin,
      emrEncounterLookback: defaultTrialFilters.emrEncounterLookback,
      tempusReportLookback: defaultTrialFilters.tempusReportLookback,
      upcomingVisitBefore: defaultTrialFilters.upcomingVisitBefore,
      upcomingVisitFilterType: defaultTrialFilters.upcomingVisitFilterType,
      upcomingVisitWithin: defaultTrialFilters.upcomingVisitWithin,
      trialId: null,
      lastUpdated: null,
    },
    options: {
      cohorts: [],
      locations: [],
      sites: [],
      trials: [],
    },
  },
};

const reducer: Reducer<TIMEScreeningState, TIMEScreeningActions> = (
  state: TIMEScreeningState = defaultState,
  action: TIMEScreeningActions,
): TIMEScreeningState => {
  switch (action.type) {
    /*
     * Care pathways related actions
     */
    case 'CLEAR_CARE_GAP_FILTERS': {
      return {
        ...state,
        careGap: {
          ...state.careGap,
          filters: {
            ...defaultCareGapFilters,
          },
        },
      };
    }
    case 'SET_CARE_GAP_FILTERS': {
      return {
        ...state,
        careGap: {
          ...state.careGap,
          filters: {
            ...state.careGap.filters,
            ...action.filters,
          },
        },
      };
    }
    case 'SET_CARE_GAP_OPTIONS': {
      return {
        ...state,
        careGap: {
          ...state.careGap,
          options: {
            ...state.careGap.options,
            ...action.options,
          },
        },
      };
    }
    /*
     * Trials related actions
     */
    case 'CLEAR_TRIAL_FILTERS': {
      return {
        ...state,
        trials: {
          ...state.trials,
          filters: {
            ...defaultTrialFilters,
            lastUpdated: state.trials.filters.lastUpdated,
          },
        },
      };
    }
    case 'SET_TRIAL_FILTERS': {
      return {
        ...state,
        trials: {
          ...state.trials,
          filters: {
            ...state.trials.filters,
            ...action.filters,
          },
        },
      };
    }
    case 'SET_TRIAL_SAVED_FILTERS': {
      return {
        ...state,
        trials: {
          ...state.trials,
          savedFilters: {
            ...state.trials.savedFilters,
            ...action.savedFilters,
          },
        },
      };
    }
    case 'SET_TRIAL_OPTIONS': {
      return {
        ...state,
        trials: {
          ...state.trials,
          options: {
            ...state.trials.options,
            ...action.options,
          },
        },
      };
    }

    default:
      return state;
  }
};

export default reducer;
